<app-search-select [keyValue]="clientKeyValue" [defaultSelected]="defaultSelected" (emitSelectedVal)="emitSelected($event)" [label]="clientLabel" [control]="control" [type]="type" 
[fetchedList]="clientData" [endpoint]="endpoint" 
[showDefaultListValue]="showDefaultListValue"
[currentScrollPosition]="currentScrollPosition"
></app-search-select>

<!-- (scrollEmit)="loadAllOnScroll($event)" -->